const { gql } = require('@apollo/client');

export const GetFullSettings = gql`
  query GetSettings {
    getFullSettings {
      freemiumInfo {
        freemiumDays
        newLabelDays
      }

      earnCreditInfo {
        inviteFriends
        referalsBuyPremium
        completeGoals
        claimPremiumDays
      }

      tags {
        countries {
          _id
          name
        }
        emotions {
          _id
          name
        }
        content {
          _id
          name
        }
        gender {
          _id
          name
        }
      }
    }
  }
`;

export const GetLiveLink = gql`
  query GetSettings {
    getFullSettings {
      liveLink
      isLive
    }
  }
`;

export const ListCreditsSettings = gql`
query ListCreditsSettings {
  listCreditsSettings {
    _id
    activity
    benefitType
    toShare
    description
    amount
    premiumDays
  }
}
`;

export const ListUserCredits = gql`
query ListUserCredits($input: ListCreditsInput!) {
  listUserCredits(input: $input) {
    docs {
      _id
      user {
        _id
        fullName
        email
      }
      count
      completed
      achieved
      creditSetting {
        _id
      }
      type
      invited
    }
    page
    limit
    totalDocs
    totalPages
  }
}`;